/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AiScanTarget, AiScanTarget$inboundSchema } from "./aiscantarget.js";

export type AiScanTargetMutationResult = {
  /**
   * Version of the served list after the change.
   */
  listVersion: number;
  /**
   * One Shadow AI scan target in an organization's list: a Speakeasy built-in, or a target the organization added.
   */
  target: AiScanTarget;
};

/** @internal */
export const AiScanTargetMutationResult$inboundSchema: z.ZodMiniType<
  AiScanTargetMutationResult,
  unknown
> = z.pipe(
  z.object({
    list_version: z.int(),
    target: AiScanTarget$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "list_version": "listVersion",
    });
  }),
);

export function aiScanTargetMutationResultFromJSON(
  jsonString: string,
): SafeParseResult<AiScanTargetMutationResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AiScanTargetMutationResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AiScanTargetMutationResult' from JSON`,
  );
}
